/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/

import type {
  ForwardGeocoding1Params,
  ForwardGeocodingParams,
  FuzzyAlgorithm,
  FuzzyPointRequest,
  FuzzyPointResponse,
  MultiPolygonG2D,
  PlaceDetails,
  PublicForwardGeocodingParams,
  PublicReverseGeocodingParams,
  ReverseGeocoding1Params,
  ReverseGeocodingParams
} from '../../models';

import { customInstance } from '../../custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Returns a fuzzy point using density and onWater checks in a deterministic way
 */
export const fuzzyPoint = (
    fuzzyPointRequest: FuzzyPointRequest,
 options?: SecondParameter<typeof customInstance<FuzzyPointResponse>>,) => {
      return customInstance<FuzzyPointResponse>(
      {url: `/api/v1/geocode/fuzzy/point`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fuzzyPointRequest
    },
      options);
    }
  /**
 * @summary Return the place details with a lat/lng. IS HEAVILY ratelimited
 */
export const publicReverseGeocoding = (
    params: PublicReverseGeocodingParams,
 options?: SecondParameter<typeof customInstance<PlaceDetails[]>>,) => {
      return customInstance<PlaceDetails[]>(
      {url: `/api/v2/public/geocode/reverse`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Returns an OSM polygon
 */
export const publicOsmPolygon = (
    osmId: string,
 options?: SecondParameter<typeof customInstance<MultiPolygonG2D>>,) => {
      return customInstance<MultiPolygonG2D>(
      {url: `/api/v2/public/geocode/osm/${osmId}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Returns the place details with a given address string. IS HEAVILY ratelimited
 */
export const publicForwardGeocoding = (
    params: PublicForwardGeocodingParams,
 options?: SecondParameter<typeof customInstance<PlaceDetails[]>>,) => {
      return customInstance<PlaceDetails[]>(
      {url: `/api/v2/public/geocode/forward`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Return the place details with a lat/lng
 */
export const reverseGeocoding = (
    params: ReverseGeocodingParams,
 options?: SecondParameter<typeof customInstance<PlaceDetails[]>>,) => {
      return customInstance<PlaceDetails[]>(
      {url: `/api/v2/geocode/reverse`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Returns the place details with a given address string
 */
export const forwardGeocoding = (
    params: ForwardGeocodingParams,
 options?: SecondParameter<typeof customInstance<PlaceDetails[]>>,) => {
      return customInstance<PlaceDetails[]>(
      {url: `/api/v2/geocode/forward`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @deprecated
 * @summary Return the place details with a lat/lng
 */
export const reverseGeocoding1 = (
    params: ReverseGeocoding1Params,
 options?: SecondParameter<typeof customInstance<PlaceDetails[]>>,) => {
      return customInstance<PlaceDetails[]>(
      {url: `/api/v1/geocode/reverse`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Returns the latest version of the fuzzy algorithm
 */
export const getFuzzyAlgorithmVersion = (

 options?: SecondParameter<typeof customInstance<FuzzyAlgorithm>>,) => {
      return customInstance<FuzzyAlgorithm>(
      {url: `/api/v1/geocode/fuzzy/version`, method: 'GET'
    },
      options);
    }
  /**
 * @deprecated
 * @summary Returns the place details with a given address string
 */
export const forwardGeocoding1 = (
    params: ForwardGeocoding1Params,
 options?: SecondParameter<typeof customInstance<PlaceDetails[]>>,) => {
      return customInstance<PlaceDetails[]>(
      {url: `/api/v1/geocode/forward`, method: 'GET',
        params
    },
      options);
    }
  export type FuzzyPointResult = NonNullable<Awaited<ReturnType<typeof fuzzyPoint>>>
export type PublicReverseGeocodingResult = NonNullable<Awaited<ReturnType<typeof publicReverseGeocoding>>>
export type PublicOsmPolygonResult = NonNullable<Awaited<ReturnType<typeof publicOsmPolygon>>>
export type PublicForwardGeocodingResult = NonNullable<Awaited<ReturnType<typeof publicForwardGeocoding>>>
export type ReverseGeocodingResult = NonNullable<Awaited<ReturnType<typeof reverseGeocoding>>>
export type ForwardGeocodingResult = NonNullable<Awaited<ReturnType<typeof forwardGeocoding>>>
export type ReverseGeocoding1Result = NonNullable<Awaited<ReturnType<typeof reverseGeocoding1>>>
export type GetFuzzyAlgorithmVersionResult = NonNullable<Awaited<ReturnType<typeof getFuzzyAlgorithmVersion>>>
export type ForwardGeocoding1Result = NonNullable<Awaited<ReturnType<typeof forwardGeocoding1>>>
